import type { DeepString } from "@/lib/i18n";

/**
 * WShopBestsellerProducts - stringi chrome okna (naglowek + CTA).
 * Etykiety kafelka (badge, status, cena, "do koszyka") pochodza z
 * `<ProductCard />` (wspoldzielony i18n `components/ui/ProductCard`).
 */
export const pl = {
  title: "Bestsellery",
  showAll: "Zobacz wszystkie",
  noProducts: "Brak bestsellerów.",
} as const;

export type WShopBestsellerProductsTranslations = DeepString<typeof pl>;
